import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[aaStepTitle]',
    standalone: false
})
export class StepTitleDirective
{
    constructor(public templateRef: TemplateRef<any>) { }
}
